<template>
  <div>
    <div class="contact-bar-mobile">
      <div class="w75 site-title">
        <h1>RM of Chaplin</h1>
      </div>
      <div class="w25">
        <button
          class="button mobile-btn"
          @click="
            () => {
              showNav = !showNav;
              noScroll = !noScroll;
            }
          "
        >
          <transition name="fade" mode="out-in">
            <i class="fas fa-bars" v-if="!showNav" :key="'menu-1'"></i>
            <i class="fas fa-times" v-else :key="'menu-2'"></i>
          </transition>
        </button>
      </div>
    </div>
    <div class="contact-bar">
      <div class="w50">
        <h1 class="site-title">RM of Chaplin</h1>
      </div>
      <div class="w50">
        <p class="text-right mb-1 p-2 contact-info">
          <span>
            <a
              v-if="contactInfo.contact_phone"
              :href="'tel:' + contactInfo.contact_phone"
            >
              <i class="fas fa-phone-alt"></i>
            </a>
            <i v-else class="fas fa-phone-alt"></i>
          </span>
          <span>
            <a
              v-if="contactInfo.contact_email"
              :href="'mailto:' + contactInfo.contact_email"
            >
              <i class="fas fa-envelope"></i>
            </a>
            <i v-else class="fas fa-envelope"></i>
          </span>
          <span class="position-relative">
            <span @click="showMap = !showMap">
              <i class="fas fa-map-marker"></i>
            </span>
            <template v-if="map === true">
              <Map
                class="position-absolute map"
                @closeMap="
                  ({ e, v }) => {
                    e.preventDefault();
                    this.map = false;
                  }
                "
              />
            </template>
          </span>
        </p>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <div class="mobile-nav" v-if="showNav">
        <div>
          <transition name="fade" mode="out-in">
            <div v-if="!selectedChildren.length" key="parent-menu">
              <router-link to="/" class="nav-item">Home</router-link>
              <span
                class="nav-item"
                @click="
                  () => {
                    this.selectedChildren = Object.keys(nav.government);
                    this.selectdParent = 'Government';
                  }
                "
                >Government</span
              ><!-- click focus on those items... -->
              <router-link to="businesses" class="nav-item"
                >Business</router-link
              >
              <span
                class="nav-item"
                @click="
                  () => {
                    this.selectedChildren = Object.keys(nav.community);
                    this.selectdParent = 'Community';
                  }
                "
                >Community</span
              ><!-- click focus on those items... -->
            </div>
            <div class="selectedLinks" v-else key="children-menu">
              <span
                class="nav-item"
                @click="
                  () => {
                    this.selectedChildren = [];
                    this.selectdParent = '';
                  }
                "
                >Back</span
              ><!-- click focus on those items... -->
              <template v-for="(selected, index) in selectedChildren">
                <router-link
                  :to="'/' + selected.toLowerCase()"
                  class="nav-item"
                  :key="'mobile-nav-' + index"
                  >{{ selected | niceTitle }}</router-link
                >
              </template>
            </div>
          </transition>

          <div class="mobile-contact">
            <div>
              <p class="text-right mb-1 p-2 contact-info">
                <span>
                  <a
                    v-if="contactInfo.contact_phone"
                    :href="'tel:' + contactInfo.contact_phone"
                  >
                    <i class="fas fa-phone-alt"></i>
                  </a>
                  <i v-else class="fas fa-phone-alt"></i>
                </span>
                <span>
                  <a
                    v-if="contactInfo.contact_email"
                    :href="'mailto:' + contactInfo.contact_email"
                  >
                    <i class="fas fa-envelope"></i>
                  </a>
                  <i v-else class="fas fa-envelope"></i>
                </span>
                <span class="position-relative text-center">
                  <span @click="showMap = !showMap">
                    <i class="fas fa-map-marker"></i>
                  </span>
                  <template v-if="map === true">
                    <Map
                      class="position-absolute map"
                      @closeMap="
                        ({ e, v }) => {
                          e.preventDefault();
                          this.map = false;
                        }
                      "
                    />
                  </template>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="desktop-nav">
      <b-nav justified>
        <b-nav-item active>
          <router-link to="/">Home</router-link>
        </b-nav-item>
        <b-nav-item-dropdown
          id="my-nav-dropdown"
          style="width: 100%"
          text="Government"
          toggle-class="nav-link-custom"
          right
        >
          <b-dropdown-item>
            <router-link to="/agm">AGM</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/bylaws">Bylaws</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/councillors">Council</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/services">Services</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-nav-item>
          <router-link to="/businesses">Business</router-link>
        </b-nav-item>
        <b-nav-item-dropdown
          id="my-nav-dropdown"
          text="Community"
          toggle-class="nav-link-custom"
          right
        >
          <b-dropdown-item>
            <router-link to="/news">News</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/events">Events</router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/galleries">Galleries</router-link>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-nav>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Map from "@/components/Map";

export default {
  name: "Nav",
  components: {
    Map: Map,
  },
  data() {
    return {
      contactInfo: {},
      nav: {
        home: "/",
        government: {
          services: "/services",
          agm: "/agm",
          bylaws: "/bylaws",
          councillors: "/councillors",
        },
        business: "/business",
        community: {
          events: "/events",
          news: "/news",
          galleries: "/galleries",
        },
      },
      showMap: false,
      siteQuery: "",
      showNav: false,
      noScroll: false,
      selectedChildren: [],
      selectdParent: "",
    };
  },
  created() {
    this.getContactInfo();
    this.getNav();
  },
  methods: {
    getContactInfo() {
      axios
        .get(process.env.VUE_APP_SERVER + "settings")
        .then((res) => {
          if (res.data) {
            this.contactInfo = res.data.result[0];
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    getNav() {},
    close(value) {
      console.log("val from map", value);
      this.map = false;
    },
    stopScrolling() {
      const body = document.querySelector("body");
      const html = document.querySelector("html");
      if (body.className.indexOf("noScroll") === -1) {
        body.classList.add("noScroll");
        html.classList.add("noScroll");
      } else {
        body.classList.remove("noScroll");
        html.classList.remove("noScroll");
      }
    },
  },
  computed: {
    map: {
      get() {
        return this.showMap;
      },
      set(value) {
        this.showMap = value;
      },
    },
  },
  watch: {
    noScroll() {
      this.stopScrolling();
    },
    $route() {
      this.noScroll = false;
      this.showNav = false;
      this.selectedChildren = [];
    },
    // siteQuery() {
    //   if (this.query.length > 2) {
    //     this.showRelatedItems();
    //   } else {
    //     this.relatedItems = this.items;
    //   }
    // }
  },
  filters: {
    niceTitle(value) {
      if (value.indexOf(" ") > -1) {
        return value
          .split(" ")
          .map((w) => {
            return w[0].toUpperCase() + w.substring(1);
          })
          .join(" ");
      } else {
        return value === "agm"
          ? value.toUpperCase()
          : value[0].toUpperCase() + value.substring(1);
      }
    },
  },
};
</script>

<style lang="scss">
.contact-bar,
.contact-bar-mobile {
  display: table;
  width: 100%;
  vertical-align: middle;
  background-color: #333;
  .w50 {
    width: 50%;
    display: table-cell;
    vertical-align: middle;

    .input-width {
      max-width: 200px;
    }
  }

  @media all and (max-width: 500px) {
    display: none;
  }
}

.contact-bar-mobile {
  display: none;
  @media all and (max-width: 500px) {
    display: table;
    padding: 0.5rem 0;
  }

  h1 {
    color: #fff;
  }

  .button,
  .mobile-btn {
    border: none !important;
    outline: none !important;
    background-color: transparent;

    color: #fff !important;
    transition: all 0.25s ease-in-out;
    &:hover,
    &:focus {
      color: #95b430 !important;
    }

    &:focus,
    &:active {
      border: none !important;
      outline: none !important;
    }
  }

  .w75,
  .w25 {
    display: table-cell;
    vertical-align: middle;
  }

  .w75 {
    width: 75%;
    h1 {
      padding-left: 0.5rem;
      font-size: 1.5rem;
      line-height: 0;
    }
  }

  .w25 {
    width: 25%;
    text-align: right;
    padding-right: 0.5rem;
  }

  .button {
    background-color: transparent;
    border: none;
  }
}

.desktop-nav {
  background-color: rgba(0, 0, 0, 0.5);
  font-weight: bold;

  .dropdown-menu {
    background-color: rgba(0, 0, 0, 0.5) !important;
    width: 100% !important;
    left: 0 !important;
  }

  a,
  .presentation {
    color: #fff !important;
    transition: all 0.25s ease-in-out;
    &:hover,
    &:focus {
      background-color: rgba(0, 0, 0, 0.5);
      color: #95b430 !important;
      a {
        background-color: initial !important;
      }
    }
  }

  .presentation {
    a {
      display: block;
      width: 100%;
    }
  }

  span {
    color: #fff !important;
    transition: all 0.25s ease-in-out;
    &:hover,
    &:focus {
      color: #95b430 !important;
      a {
        a {
          background-color: initial !important;
        }
      }
    }
  }

  @media all and (max-width: 500px) {
    display: none;
  }
}

.mobile-nav {
  display: none;
  width: 100%;
  @media all and (max-width: 500px) {
    display: block;
    position: fixed;
    z-index: 9999;
    top: 40px;
    height: calc(100vh - 40px);
    background-color: rgba(0, 0, 0, 0.5);

    .nav-item {
      &:first-child {
        margin-top: 3rem;
      }
      display: block;
      text-align: center;
      width: 100%;
      padding: 1.5rem 0;
      font-size: 1.5rem;
      font-weight: bold;
      color: #fff;

      transition: all 0.25s ease-in-out;

      &:hover,
      &:focus {
        background-color: rgba(0, 0, 0, 0.5);
        color: #95b430;
      }
    }

    .selectedLinks {
      .nav-item {
        padding: 1rem 0 !important;
      }
    }
  }

  .mobile-contact {
    position: absolute;
    bottom: 0;
    width: 100%;
    .search-item {
      width: 100%;
    }
    .contact-info {
      display: table;
      width: 100%;
      span {
        display: table-cell;
        width: 33%;
        text-align: center;
        &.position-relative {
          span {
            width: 100% !important;
            display: block;
            margin-left: 0.5rem;
          }
        }
      }
    }
  }
}

.contact-info {
  span {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .fa-map-marker,
  .fa-envelope,
  .fa-phone-alt {
    color: #fff;

    transition: all 0.25s ease-in-out;

    &:hover,
    &:focus {
      color: #95b430;
    }
  }
}

.map {
  right: 0;
  top: 0;

  @media all and (max-width: 500px) {
    top: initial !important;
    bottom: 30px;
    right: -4px;
    width: 96%;
    min-width: 310px;
    max-width: 500px;

    p.text-right {
      text-align: center;

      span {
        margin-left: 0 !important;
      }
    }

    iframe {
      width: 100% !important;
      min-width: 35px !important;
      max-width: 96vw !important;
    }

    @media all and (min-width: 411px) {
      width: 404px;
    }

    @media all and (min-width: 410px) {
      width: 403px;
    }

    @media all and (min-width: 375px) and (max-width: 376px) {
      width: 366px;
    }

    @media all and (min-width: 360px) and (max-width: 361px) {
      width: 353px;
    }
  }
}

.search-item {
  border: solid 1px #ccc;
  border-radius: 20px;
  padding: 0.45rem;
  padding-left: 1rem;
  &:focus {
    outline: none;
  }
}

.site-title {
  color: #fff;
  position: relative;
  left: 1rem;
  font-family: "Titan One", cursive;
  @media all and (max-width: 500px) {
    left: 0;
    top: 0.25rem;
  }
}
</style>
